// extracted by mini-css-extract-plugin
export var currencyInput = "_ki-1";
export var currencySymbol = "_ki-0";